// extracted by mini-css-extract-plugin
export default {"accessDenied":"styles_accessDenied__h3bf0"};